import styled from 'styled-components';

export const Container = styled.div`
    background: linear-gradient(
      343.07deg,
      rgba(133, 76, 230, 0.04) 5.71%,
      rgba(133, 76, 230, 0) 64.83%
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 0;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 10px 0 100px;
    gap: 12px;
`;

export const Title = styled.h2`
    font-size: 42px;
    text-align: center;
    font-weight: 700;
    margin-top: 20px;
    color: ${({ theme }) => theme.text_primary};
    letter-spacing: -0.5px;

    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 32px;
    }
`;

export const Desc = styled.div`
    font-size: 17px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    line-height: 1.6;

    @media (max-width: 768px) {
        font-size: 15px;
        padding: 0 16px;
    }
`;

export const ToggleButtonGroup = styled.div`
    display: flex;
    border: 1px solid ${({ theme }) => theme.divider};
    color: ${({ theme }) => theme.text_secondary};
    font-size: 15px;
    border-radius: 12px;
    font-weight: 500;
    margin: 22px 0;
    overflow: hidden;
    background: ${({ theme }) => theme.card};
    backdrop-filter: blur(10px);

    @media (max-width: 768px) {
        font-size: 13px;
    }
`

export const ToggleButton = styled.div`
    padding: 10px 22px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    color: ${({ active, theme }) => active ? theme.white : theme.text_secondary};
    background: ${({ active, theme }) => active ? theme.primary : 'transparent'};
    font-weight: ${({ active }) => active ? 600 : 500};

    &:hover {
        color: ${({ active, theme }) => active ? theme.white : theme.text_primary};
        background: ${({ active, theme }) => active ? theme.primary : theme.primary_light};
    }

    @media (max-width: 768px) {
        padding: 8px 14px;
    }
`

export const Divider = styled.div`
    width: 1px;
    background: ${({ theme }) => theme.divider};
`

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 900px;
    gap: 20px;
    padding: 0 16px;

    @media (max-width: 768px) {
        gap: 14px;
        padding: 0 12px;
    }
`;
